import React from 'react';
import CheckoutTimer from '../checkout-components/CheckoutTimer';
import { useBuilderStore } from '../../../store/checkoutBuilder/BuilderContext';

interface TimerAdapterProps {
  componentId: string;
  selected: boolean;
  zone?: 'top' | 'side' | 'bottom';
  dragHandleProps?: any;
}

const TimerAdapter: React.FC<TimerAdapterProps> = ({ componentId, selected, dragHandleProps }) => {
  const { state, selectNode, deleteNode, duplicateNode } = useBuilderStore();
  const component = state.document.nodes[componentId];

  if (!component || component.type !== 'component') {
    return null;
  }

  const config = component.props || {
    timerType: 'minutes',
    backgroundColor: '#ef4444',
    textColor: '#ffffff',
    timeValue: 15,
    activeText: 'Oferta por tempo limitado',
    expiredText: 'O tempo acabou!',
    fixedTop: false
  };

  const handleSelect = () => {
    selectNode(componentId);
  };


  const handleDelete = () => {
    if (window.confirm('Tem certeza que deseja excluir este cronômetro?')) {
      deleteNode(componentId);
    }
  };

  const handleDuplicate = () => {
    duplicateNode(componentId);
  };

  return (
    <CheckoutTimer
      selected={selected}
      config={config}
      onSelect={handleSelect}
      onDelete={handleDelete}
      onDuplicate={handleDuplicate}
      dragHandleProps={dragHandleProps}
    />
  );
};

export default TimerAdapter;
